import type { RecommendedSortResults } from '@jane/bloom/loaders/products/recommendedSortResults.server';
import type { Facet } from '@jane/bloom/types/facet';
import { buildProductSearchFiltersViewModel } from '@jane/bloom/viewModels/filters/productSearchFilters';
import { hasAnyFiltersApplied } from '@jane/bloom/viewModels/filters/utils';

import { get, reset, set } from './storage';

type EnhanceableLoaderArgs = Pick<
  RecommendedSortResults,
  'filterArgs' | 'searchCriteria'
>;

export const enhanceWithFilterState = async ({
  filterArgs,
  searchCriteria,
}: EnhanceableLoaderArgs) => {
  const hasFiltersApplied = hasAnyFiltersApplied(searchCriteria);
  if (!hasFiltersApplied) {
    reset();
  }

  const setLocalStorageCallback = (
    facetGroup: string,
    facetData: NonNullable<Facet>
  ) => {
    const existingFilters = get();
    set({
      ...existingFilters,
      [facetGroup]: facetData,
    });
  };

  const availableFilters = buildProductSearchFiltersViewModel({
    ...filterArgs,
    frozenFacetsStateClient: get(),
    setLocalStorageCallback: hasFiltersApplied
      ? setLocalStorageCallback
      : undefined,
  });

  return availableFilters;
};
